import { useEffect, useRef } from "react";

/**
 * Google AdSense responsive display slot.
 * The verification script is loaded once in /app/frontend/public/index.html.
 *
 * IMPORTANT: after AdSense approval, replace `data-ad-slot` below with the
 * slot ID you create in your AdSense dashboard (Ad units → Display ads).
 * Until then this ad container remains reserved but hidden.
 */
const AD_CLIENT = "ca-pub-1610110871131207";
const AD_SLOT = ""; // <-- paste your ad-unit slot ID here (e.g. "1234567890")

const AdSlot = ({ className = "" }) => {
  const insRef = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (!AD_SLOT || pushed.current || !insRef.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch (_) {
      /* silent — AdSense retries on next navigation */
    }
  }, []);

  // Only render the ad container once a real slot ID is provided,
  // so the layout stays clean during pre-approval / demo mode.
  if (!AD_SLOT) return null;

  return (
    <div
      className={`w-full flex justify-center ${className}`}
      data-testid="ad-slot"
      aria-label="Advertisement"
    >
      <ins
        ref={insRef}
        className="adsbygoogle block w-full max-w-[970px]"
        style={{ display: "block", minHeight: 90 }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={AD_SLOT}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdSlot;
